import { Controller } from "stimulus"

export default class extends Controller {
  open(event) {
    if (event.defaultPrevented || event.button !== 0) return
    if (event.target.closest("a, button, input, select, textarea, label, form, .modal, .speaker-hover, [contenteditable], [data-toggle], [data-bs-toggle]")) return
    if (window.getSelection()?.toString()) return

    const link = this.element.querySelector("a.portal-provider-title")
    if (!link) return

    if (event.ctrlKey || event.metaKey || event.shiftKey) {
      window.open(link.href, "_blank", "noopener")
    } else {
      link.click()
    }
  }
}
